import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import Lenis from "@studio-freight/lenis";
import Swiper from "swiper";
import {
	Navigation,
	Pagination,
	// FreeMode,
	// Controller,
	Thumbs,
	// Scrollbar,
	Autoplay,
} from "swiper/modules";
import MicroModal from "micromodal";

(function ($, root, undefined) {
	$(function () {
		"use strict";

		gsap.registerPlugin(ScrollTrigger, SplitText, MorphSVGPlugin);

		const lenis = new Lenis({
			lerp: 0.2,
		});

		lenis.on("scroll", ScrollTrigger.update);

		gsap.ticker.add((time) => {
			lenis.raf(time * 1000);
		});

		gsap.ticker.lagSmoothing(0);

		console.log(
			"%cCreated by Konfiture",
			"color: #000; padding: 5px 0px 1px; border-bottom:2px solid #1A1A1A;"
		),
			console.log("%chttps://konfiture.com", "color:#ccc");

		let $body = $("body");

		/*
This helper function makes a group of elements animate along the x-axis in a seamless, responsive loop.

Features:
 - Uses xPercent so that even if the widths change (like if the window gets resized), it should still work in most cases.
 - When each item animates to the left or right enough, it will loop back to the other side
 - Optionally pass in a config object with values like draggable: true, center: true, speed (default: 1, which travels at roughly 100 pixels per second), paused (boolean), repeat, reversed, and paddingRight.
 - The returned timeline will have the following methods added to it:
   - next() - animates to the next element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
   - previous() - animates to the previous element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
   - toIndex() - pass in a zero-based index value of the element that it should animate to, and optionally pass in a vars object to control duration, easing, etc. Always goes in the shortest direction
   - current() - returns the current index (if an animation is in-progress, it reflects the final index)
   - times - an Array of the times on the timeline where each element hits the "starting" spot.
 */
		function horizontalLoop(items, config) {
			let timeline;
			items = gsap.utils.toArray(items);
			config = config || {};
			gsap.context(() => {
				// use a context so that if this is called from within another context or a gsap.matchMedia(), we can perform proper cleanup like the "resize" event handler on the window
				let onChange = config.onChange,
					lastIndex = 0,
					tl = gsap.timeline({
						repeat: config.repeat,
						onUpdate:
							onChange &&
							function () {
								let i = tl.closestIndex();
								if (lastIndex !== i) {
									lastIndex = i;
									onChange(items[i], i);
								}
							},
						paused: config.paused,
						defaults: { ease: "none" },
						onReverseComplete: () =>
							tl.totalTime(tl.rawTime() + tl.duration() * 100),
					}),
					length = items.length,
					startX = items[0].offsetLeft,
					times = [],
					widths = [],
					spaceBefore = [],
					xPercents = [],
					curIndex = 0,
					indexIsDirty = false,
					center = config.center,
					pixelsPerSecond = (config.speed || 1) * 100,
					snap =
						config.snap === false
							? (v) => v
							: gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
					timeOffset = 0,
					container =
						center === true
							? items[0].parentNode
							: gsap.utils.toArray(center)[0] || items[0].parentNode,
					totalWidth,
					getTotalWidth = () =>
						items[length - 1].offsetLeft +
						(xPercents[length - 1] / 100) * widths[length - 1] -
						startX +
						spaceBefore[0] +
						items[length - 1].offsetWidth *
							gsap.getProperty(items[length - 1], "scaleX") +
						(parseFloat(config.paddingRight) || 0),
					populateWidths = () => {
						let b1 = container.getBoundingClientRect(),
							b2;
						items.forEach((el, i) => {
							widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
							xPercents[i] = snap(
								(parseFloat(gsap.getProperty(el, "x", "px")) / widths[i]) *
									100 +
									gsap.getProperty(el, "xPercent")
							);
							b2 = el.getBoundingClientRect();
							spaceBefore[i] = b2.left - (i ? b1.right : b1.left);
							b1 = b2;
						});
						gsap.set(items, {
							// convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
							xPercent: (i) => xPercents[i],
						});
						totalWidth = getTotalWidth();
					},
					timeWrap,
					populateOffsets = () => {
						timeOffset = center
							? (tl.duration() * (container.offsetWidth / 2)) / totalWidth
							: 0;
						center &&
							times.forEach((t, i) => {
								times[i] = timeWrap(
									tl.labels["label" + i] +
										(tl.duration() * widths[i]) / 2 / totalWidth -
										timeOffset
								);
							});
					},
					getClosest = (values, value, wrap) => {
						let i = values.length,
							closest = 1e10,
							index = 0,
							d;
						while (i--) {
							d = Math.abs(values[i] - value);
							if (d > wrap / 2) {
								d = wrap - d;
							}
							if (d < closest) {
								closest = d;
								index = i;
							}
						}
						return index;
					},
					populateTimeline = () => {
						let i, item, curX, distanceToStart, distanceToLoop;
						tl.clear();
						for (i = 0; i < length; i++) {
							item = items[i];
							curX = (xPercents[i] / 100) * widths[i];
							distanceToStart =
								item.offsetLeft + curX - startX + spaceBefore[0];
							distanceToLoop =
								distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
							tl.to(
								item,
								{
									xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
									duration: distanceToLoop / pixelsPerSecond,
								},
								0
							)
								.fromTo(
									item,
									{
										xPercent: snap(
											((curX - distanceToLoop + totalWidth) / widths[i]) * 100
										),
									},
									{
										xPercent: xPercents[i],
										duration:
											(curX - distanceToLoop + totalWidth - curX) /
											pixelsPerSecond,
										immediateRender: false,
									},
									distanceToLoop / pixelsPerSecond
								)
								.add("label" + i, distanceToStart / pixelsPerSecond);
							times[i] = distanceToStart / pixelsPerSecond;
						}
						timeWrap = gsap.utils.wrap(0, tl.duration());
					},
					refresh = (deep) => {
						let progress = tl.progress();
						tl.progress(0, true);
						populateWidths();
						deep && populateTimeline();
						populateOffsets();
						deep && tl.draggable
							? tl.time(times[curIndex], true)
							: tl.progress(progress, true);
					},
					onResize = () => refresh(true),
					proxy;
				gsap.set(items, { x: 0 });
				populateWidths();
				populateTimeline();
				populateOffsets();
				window.addEventListener("resize", onResize);
				function toIndex(index, vars) {
					vars = vars || {};
					Math.abs(index - curIndex) > length / 2 &&
						(index += index > curIndex ? -length : length); // always go in the shortest direction
					let newIndex = gsap.utils.wrap(0, length, index),
						time = times[newIndex];
					if (time > tl.time() !== index > curIndex && index !== curIndex) {
						// if we're wrapping the timeline's playhead, make the proper adjustments
						time += tl.duration() * (index > curIndex ? 1 : -1);
					}
					if (time < 0 || time > tl.duration()) {
						vars.modifiers = { time: timeWrap };
					}
					curIndex = newIndex;
					vars.overwrite = true;
					gsap.killTweensOf(proxy);
					return vars.duration === 0
						? tl.time(timeWrap(time))
						: tl.tweenTo(time, vars);
				}
				tl.toIndex = (index, vars) => toIndex(index, vars);
				tl.closestIndex = (setCurrent) => {
					let index = getClosest(times, tl.time(), tl.duration());
					if (setCurrent) {
						curIndex = index;
						indexIsDirty = false;
					}
					return index;
				};
				tl.current = () => (indexIsDirty ? tl.closestIndex(true) : curIndex);
				tl.next = (vars) => toIndex(tl.current() + 1, vars);
				tl.previous = (vars) => toIndex(tl.current() - 1, vars);
				tl.times = times;
				tl.progress(1, true).progress(0, true); // pre-render for performance
				if (config.reversed) {
					tl.vars.onReverseComplete();
					tl.reverse();
				}
				if (config.draggable && typeof Draggable === "function") {
					proxy = document.createElement("div");
					let wrap = gsap.utils.wrap(0, 1),
						ratio,
						startProgress,
						draggable,
						dragSnap,
						lastSnap,
						initChangeX,
						wasPlaying,
						align = () =>
							tl.progress(
								wrap(startProgress + (draggable.startX - draggable.x) * ratio)
							),
						syncIndex = () => tl.closestIndex(true);
					typeof InertiaPlugin === "undefined" &&
						console.warn(
							"InertiaPlugin required for momentum-based scrolling and snapping. https://greensock.com/club"
						);
					draggable = Draggable.create(proxy, {
						trigger: items[0].parentNode,
						type: "x",
						onPressInit() {
							let x = this.x;
							gsap.killTweensOf(tl);
							wasPlaying = !tl.paused();
							tl.pause();
							startProgress = tl.progress();
							refresh();
							ratio = 1 / totalWidth;
							initChangeX = startProgress / -ratio - x;
							gsap.set(proxy, { x: startProgress / -ratio });
						},
						onDrag: align,
						onThrowUpdate: align,
						overshootTolerance: 0,
						inertia: true,
						snap(value) {
							//note: if the user presses and releases in the middle of a throw, due to the sudden correction of proxy.x in the onPressInit(), the velocity could be very large, throwing off the snap. So sense that condition and adjust for it. We also need to set overshootTolerance to 0 to prevent the inertia from causing it to shoot past and come back
							if (Math.abs(startProgress / -ratio - this.x) < 10) {
								return lastSnap + initChangeX;
							}
							let time = -(value * ratio) * tl.duration(),
								wrappedTime = timeWrap(time),
								snapTime = times[getClosest(times, wrappedTime, tl.duration())],
								dif = snapTime - wrappedTime;
							Math.abs(dif) > tl.duration() / 2 &&
								(dif += dif < 0 ? tl.duration() : -tl.duration());
							lastSnap = (time + dif) / tl.duration() / -ratio;
							return lastSnap;
						},
						onRelease() {
							syncIndex();
							draggable.isThrowing && (indexIsDirty = true);
						},
						onThrowComplete: () => {
							syncIndex();
							wasPlaying && tl.play();
						},
					})[0];
					tl.draggable = draggable;
				}
				tl.closestIndex(true);
				lastIndex = curIndex;
				onChange && onChange(items[curIndex], curIndex);
				timeline = tl;
				return () => window.removeEventListener("resize", onResize); // cleanup
			});
			return timeline;
		}

		function loaderTransition() {
			var loaderTl = gsap.timeline();
			loaderTl
				.to(".loader-content", {
					autoAlpha: 0,
					duration: 0.25,
					ease: "none",
				})
				.to(".morph", {
					duration: 1,
					ease: "expo.in",
					morphSVG: "M0,0V1080s339.952-560,960-560,960,560,960,560V0Z",
					delay: -0.5,
				})
				.to(".morph", {
					duration: 1,
					ease: "expo.out",
					morphSVG: "M0-.054V0H1921.054V-.054Z",
				});
		}

		function generalScripts() {
			/**
			 * Add padding to top of body the size of siteNav
			 */
			let $spacer = "206px";
			if ($("window").width() < 992) {
				$spacer = "190px";
			} else if ($("window").width() < 576) {
				$spacer = "165px";
			} else {
				$spacer = "206px";
			}
			$(".site-main").css("padding-top", $spacer);

			/**
			 * Menu toggler
			 */
			// $(".menu-toggle").on("click", function () {
			// 	if (!$body.hasClass("menu-open")) {
			// 		$body.addClass("menu-open");
			// 		lenis.stop();
			// 	} else {
			// 		$body.removeClass("menu-open");
			// 		lenis.start();
			// 	}
			// });

			/**
			 * Menu toggler
			 */
			// $('.menu-item-has-children').hover(function () {
			//   $('.menu-overlay').addClass('--show');
			// });

			$(".menu-item-has-children").hover(
				function () {
					$body.addClass("sub-menu-open");
					$(".menu-overlay").addClass("--show");
				},
				function () {
					$body.removeClass("sub-menu-open");
					$(".menu-overlay").removeClass("--show");
				}
			);

			/**
			 * Animate logo
			 */
			document.querySelector("body").addEventListener("mousemove", eyeball);
			function eyeball() {
				var eye = document.querySelectorAll(".eye");
				eye.forEach(function (eye) {
					let x = eye.getBoundingClientRect().left + eye.clientWidth / 2;
					let y = eye.getBoundingClientRect().top + eye.clientHeight / 2;
					let radian = Math.atan2(event.pageX - x, event.pageY - y);
					let rot = radian * (180 / Math.PI) * 1 + 270;
					eye.style.transform = "rotate(-" + rot + "deg)";
				});
			}
			// $('body').mousemove(function (event) {
			//   // console.log('x: ' + event.pageX + '; y: ' + event.pageY);
			//   var eyeBall = $('.eye');
			//   var x = (eyeBall.offset().left) + (eyeBall.width() / 2);
			//   var y = (eyeBall.offset().top) + (eyeBall.height() / 2);
			//   var rad = Math.atan2(event.pageX - x, event.pageY - y);
			//   var rot = (rad * (180 / Math.PI) * -1) + 180;
			//   eyeBall.css({
			//     '-webkit-transform': 'rotate(' + rot + 'deg)',
			//     '-moz-transform': 'rotate(' + rot + 'deg)',
			//     '-ms-transform': 'rotate(' + rot + 'deg)',
			//     'transform': 'rotate(' + rot + 'deg)'
			//   });
			// });

			// Parallax effects on scroll
			let initSpd = 50;

			if (window.innerWidth < 992) {
				initSpd = initSpd / 2;
			}

			$("[data-speed]").each(function (index) {
				var parallaxTl = gsap.timeline({
					scrollTrigger: {
						trigger: $(this),
						start: "top 100%",
						end: "bottom 0%",
						scrub: true,
						// markers: true,
					},
				});

				gsap.set($(this), {
					y: $(this).data("speed") * initSpd,
				});

				parallaxTl.to($(this), {
					y: -$(this).data("speed") * initSpd,
					scale: 1,
					ease: "none",
				});
			});

			/**
			 *  Animate titles
			 */
			let $titleFirstPart = $(".page-title--sliding > .big:nth-child(1)"),
				$titleSecondPart = $(".page-title--sliding > .big:nth-child(2)"),
				horizontalDirection;

			if ($(window).width() > 1200 || $(".page-title--sliding") > 0) {
				if ($(".page-title--sliding > .big").length == 1) {
					horizontalDirection = -200;
				} else {
					horizontalDirection = 200;
				}

				let titleTw = gsap.timeline({
					scrollTrigger: {
						trigger: "body",
						// scroller: '.smooth-scroll',
						start: "top 0%",
						scrub: true,
						// markers: true,
						// toggleActions: 'play pause reverse pause'
					},
				});

				titleTw.to(
					$titleFirstPart,
					{
						xPercent: horizontalDirection,
						// yPercent: 750,
						ease: "none",
					},
					"0"
				);

				if ($titleSecondPart.length > 0) {
					titleTw.to(
						$titleSecondPart,
						{
							xPercent: -200,
							// yPercent: 750,
							ease: "none",
						},
						"0"
					);
				}
			}

			$(".cart > a").on("click", function (e) {
				e.preventDefault();

				$body.addClass("quickview-open");

				lenis.stop();
			});

			$(".cart-quickview .close").on("click", function () {
				$body.removeClass("quickview-open");

				lenis.start();
			});

			/**
			 * Marquee
			 *
			 * @require gsap
			 *
			 **/
			$(".site-marquee").each(function () {
				const loop = horizontalLoop($(this).children(), {
					speed: 1,
					repeat: -1,
				});
			});

			/**
			 * Reveals
			 *
			 * @require gsap
			 * @require scrollmagic
			 *
			 **/

			// Default reveal
			if ($(".reveal").length > 0) {
				$(".reveal").each(function () {
					let tl = gsap.timeline({
						scrollTrigger: {
							trigger: this,
							// scroller: '.smooth-scroll',
							start: "top 80%",
							// markers: true
						},
					});
					tl.to($(this).find("> *"), {
						transformOrigin: "50% 100%",
						y: 0,
						scale: 1,
						autoAlpha: 1,
						ease: "power4.out",
						duration: 1,
						stagger: 0.08,
					});
				});
			}

			// Picture reveal
			if ($(".picture-reveal").length > 0) {
				$(".picture-reveal").each(function () {
					let tl = gsap.timeline({
						scrollTrigger: {
							trigger: this,
							// scroller: '.smooth-scroll',
							start: "top 80%",
							// markers: true
						},
					});
					tl.to($(this).find("div"), {
						scaleY: 0,
						ease: "power4.out",
						duration: 1,
					}).to($(this).find("img"), {
						y: "0px",
						ease: "power4.out",
						duration: 1,
						delay: -1,
					});
				});
			}

			/**
			 * Spliced text reveal
			 *
			 * @require gsap, SplitText
			 *
			 **/
			if ($(".spliced-text").length > 0) {
				$(".spliced-text").each(function () {
					var splitText = new SplitText($(this), {
						charsClass: "spliced-text-char",
						reduceWhiteSpace: false,
					});
					var tw = gsap.fromTo(
						$(this).find(".spliced-text-char"),
						{
							scale: 0.9,
							y: "10px",
							autoAlpha: 0,
						},
						{
							scale: 1,
							y: "0px",
							autoAlpha: 1,
							ease: "power4.out",
							duration: 0.8,
							stagger: 0.015,
							scrollTrigger: {
								trigger: this,
								// scroller: '.smooth-scroll',
								start: "top 80%",
								// markers: true
							},
						}
					);
				});
			}
		}

		// if (document.querySelector(".wp-block-yoast-faq-block")) {
		// 	var yoast = {
		// 		accordion: function () {
		// 			$(".wp-block-yoast-faq-block")
		// 				.find(".schema-faq-question")
		// 				.click(function () {
		// 					//Expand or collapse this panel
		// 					$(this)
		// 						.nextAll(".schema-faq-answer")
		// 						.eq(0)
		// 						.slideToggle(300, function () {
		// 							if ($(this).hasClass("collapse")) {
		// 								$(this).removeClass("collapse");
		// 							} else {
		// 								$(this).addClass("collapse");
		// 							}
		// 						});

		// 					//Hide the other panels
		// 					$(".schema-faq-answer")
		// 						.not($(this).nextAll(".schema-faq-answer").eq(0))
		// 						.slideUp("fast");

		// 					ScrollTrigger.refresh();
		// 				});

		// 			$(".wp-block-yoast-faq-block .schema-faq-question").click(
		// 				function () {
		// 					$(".wp-block-yoast-faq-block .schema-faq-question")
		// 						.not($(this))
		// 						.removeClass("collapse");
		// 					if ($(this).hasClass("collapse")) {
		// 						$(this).removeClass("collapse");
		// 					} else {
		// 						$(this).addClass("collapse");
		// 					}
		// 					ScrollTrigger.refresh();
		// 				}
		// 			);
		// 		},
		// 	};

		// 	yoast.accordion();
		// }

		function generalMobileScripts() {
			//
		}

		function wooScripts() {
			/**
			 *  Refresh mini cart
			 */
			// $(".site-controls .cart").click(function (e) {
			// 	e.preventDefault();
			// 	console.log(woocommerce_params);

			// 	jQuery.ajax({
			// 		url: woocommerce_params.ajax_url,
			// 		type: "post",
			// 		dataType: "json",
			// 		data: {
			// 			action: "ajax_update_mini_cart",
			// 		},
			// 		success: function (response) {
			// 			$("#mini-cart-container").html(response);
			// 		},
			// 	});
			// });

			/**
			 * On added to cart
			 */
			$("body").on("added_to_cart", function () {
				// $('.added').find('span:not(".checkmark")').html('Ajouté au panier');

				setTimeout(function () {
					// $('.checkmark').remove();
					$(".added").removeClass("added");
				}, 2000);
			});

			/**
			 * Auto update cart on qty input changed
			 */
			let timeout;
			$(".woocommerce").on("change", "input.qty", function () {
				if (timeout !== undefined) {
					clearTimeout(timeout);
				}
				timeout = setTimeout(function () {
					$("[name='update_cart']").trigger("click"); // trigger cart update
				}, 1000); // 1 second delay, half a second (500) seems comfortable too
			});

			/**
			 *  Init quantity input
			 */
			if ($(".quantity-button").length > 0) {
				$(".quantity-button").on("click", function () {
					var $this = $(this);
					var $input = $this.parent().find("input");
					var $quantity = $input.val();
					var $new_quantity = 0;
					if ($this.hasClass("plus")) {
						var $new_quantity = parseFloat($quantity) + 1;
					} else {
						if ($quantity > 0) {
							var $new_quantity = parseFloat($quantity) - 1;
						}
					}
					$input.val($new_quantity).trigger("change");
				});
			}

			/**
			 * Hide add to cart notices and errors
			 */
			if ($(".woocommerce-notices-wrapper").length > 0) {
				$(".woocommerce-notices-wrapper .close").on("click", function () {
					$(".woocommerce-notices-wrapper").addClass("hidden");
				});
			}
		}

		/**
		 * Single product animations
		 */
		function frontPageScripts() {
			const tattooSwitcher = new Swiper(".swiper", {
				modules: [Autoplay],
				slidesPerView: 1,
				slidesPerGroup: 1,
				speed: 1,
				allowTouchMove: false,
				draggable: false,
				autoplay: {
					delay: 1000,
				},
			});

			if ($(window).width() > 992) {
				// tattooSwitcher.autoplay.stop();

				$(".page-title").hover(
					function () {
						tattooSwitcher.autoplay.pause();
					},
					function () {
						tattooSwitcher.autoplay.resume();
					}
				);
			}
		}

		/**
		 * Single product animations
		 */
		function initSingleProduct() {
			if ($(window).width() > 992) {
				// Fix product gallery on scroll
				ScrollTrigger.create({
					trigger: "#gallery-pin",
					start: "top " + $(".site-header").outerHeight() + "px",
					end: "bottom 90%",
					// markers: true,
					pin: ".product__gallery",
					pinSpacer: false,
					pinSpacing: false,
				});
			}

			/**
			 * Ajax add to cart on single product page
			 */
			if (typeof wc_add_to_cart_params === "undefined") {
				return false;
			}

			$(document).on("submit", "form.cart", function (e) {
				var form = $(this),
					button = form.find(".single_add_to_cart_button");

				var formFields = form.find(
					'input:not([name="product_id"]), select, button, textarea'
				);

				// create the form data array
				var formData = [];
				formFields.each(function (i, field) {
					// store them so you don't override the actual field's data
					var fieldName = field.name,
						fieldValue = field.value;

					if (fieldName && fieldValue) {
						// set the correct product/variation id for single or variable products
						if (fieldName == "add-to-cart") {
							fieldName = "product_id";
							fieldValue =
								form.find("input[name=variation_id]").val() || fieldValue;
						}

						// if the fiels is a checkbox/radio and is not checked, skip it
						if (
							(field.type == "checkbox" || field.type == "radio") &&
							field.checked == false
						) {
							return;
						}

						// add the data to the array
						formData.push({
							name: fieldName,
							value: fieldValue,
						});
					}
				});

				if (!formData.length) {
					return;
				}

				e.preventDefault();

				form.block({
					message: null,
					overlayCSS: {
						background: "#ffffff",
						opacity: 0.6,
					},
				});

				$(document.body).trigger("adding_to_cart", [button, formData]);

				$.ajax({
					type: "POST",
					url: woocommerce_params.wc_ajax_url
						.toString()
						.replace("%%endpoint%%", "add_to_cart"),
					data: formData,
					success: function (response) {
						if (!response) {
							return;
						}

						if (response.error & response.product_url) {
							window.location = response.product_url;
							return;
						}

						$(document.body).trigger("added_to_cart", [
							response.fragments,
							response.cart_hash,
							button,
						]);
					},
					complete: function () {
						form.unblock();
					},
				});

				return false;
			});

			const reviews = new Swiper(".product-reviews", {
				modules: [Navigation],
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				slidesPerView: 1,
				spaceBetween: 30,
				// enable: false, // Disable swiper at start
				breakpoints: {
					768: {
						slidesPerView: 2,
					},
				},
			});
		}

		/**
		 * Archive product
		 *
		 */
		function archiveProduct() {
			$(document).on("awf_after_ajax_products_update", () => {
				ScrollTrigger.refresh();
			});

			$("img[loading=lazy").on("load", () => {
				ScrollTrigger.refresh();
			});
		}

		/**
		 * Checkout
		 *
		 * Add class on before form toggles
		 *
		 */
		function initCheckout() {
			/**
			 * Add class on before form toggles
			 */
			$(".checkout__toggle").on("click", function () {
				$(this).toggleClass("open");
				$(this).siblings().slideToggle();
			});

			/**
			 * Pin #order_review sidebar on scroll
			 */
			// if($(window).width() > 992) {
			//   var checkoutSc = new ScrollMagic.Scene({
			//     triggerElement: '#order_review',
			//     triggerHook: 0,
			//     offset: -$('.site-header').outerHeight(),
			//     duration: $('.site-footer').offset().top - $('.site-header').outerHeight() - $('#order_review').outerHeight()
			//   });
			//   checkoutSc.setPin('#order_review').addTo(controller);
			// }
		}

		/**
		 * Do stuff on window loaded
		 */
		$(document).on("mouseup", function (e) {
			var cartQuickview = $(".cart-quickview__content");

			if (
				!cartQuickview.is(e.target) &&
				cartQuickview.has(e.target).length === 0
			) {
				$body.removeClass("quickview-open");
				lenis.start();
			}
		});

		window.onload = (function () {
			// loaderTransition();
			$body.addClass("is-loaded");
			$("#page").removeClass("hidden");

			ScrollTrigger.create({
				trigger: "body",
				start: "100px top",
				// markers: true,
				onEnter: () => {
					$("body").addClass("menu-small");
				},
				onLeaveBack: () => {
					$("body").removeClass("menu-small");
				},
			});
		})();

		// document.on("updated_cart_totals", () => {
		// 	console.log("updated_cart_totals triggered");
		// });

		$(document).ready(function () {
			document.addEventListener("lazyloaded", function () {
				ScrollTrigger.refresh();
			});

			// Init modals
			MicroModal.init({
				onShow: (modal) => {
					lenis.stop();
				},
				onClose: (modal) => {
					lenis.start();
				},
			});

			$("details summary").on("click", function () {
				ScrollTrigger.refresh();
			});

			// FAQ accordion
			var $faq = jQuery(".schema-faq");
			var $questions = $faq.find(".schema-faq-question");
			var $answers = $faq.find(".schema-faq-answer");

			$questions.each(function (index) {
				var answerId = "faq-answer-" + (index + 1);
				var question = jQuery(this).text();
				jQuery(this)
					.next(".schema-faq-answer")
					.attr("id", answerId)
					.attr("aria-hidden", "true")
					.attr("aria-labelledby", "faq-question-" + (index + 1));
				jQuery(this).replaceWith(
					'<a class="schema-faq-question" href="#" aria-expanded="false" tabindex="0" id="faq-question-' +
						(index + 1) +
						'" aria-controls="' +
						answerId +
						'">' +
						question +
						"</a>"
				);
			});

			$questions = $faq.find(".schema-faq-question"); // reassign $questions variable to include new anchor tags

			$questions.on("click keydown", function (event) {
				if (
					event.type === "click" ||
					event.keyCode === 13 ||
					event.keyCode === 32
				) {
					var $this = jQuery(this);
					var $thisAnswer = $this.siblings(".schema-faq-answer");

					$questions
						.not(this)
						.removeClass("faq-q-open")
						.attr("aria-expanded", "false");
					$answers
						.not($thisAnswer)
						.removeClass("faq-a-open")
						.slideUp()
						.attr("aria-hidden", "true");

					if ($thisAnswer.is(":visible")) {
						$this.removeClass("faq-q-open").attr("aria-expanded", "false");
						$thisAnswer
							.removeClass("faq-a-open")
							.slideUp()
							.attr("aria-hidden", "true");
					} else {
						$this.addClass("faq-q-open").attr("aria-expanded", "true");
						$thisAnswer
							.addClass("faq-a-open")
							.slideDown()
							.attr("aria-hidden", "false");
					}
					event.preventDefault();
				}
			});

			generalScripts();
			wooScripts(); // WooCommerce-related custom scripts

			$(window).width() < 992 ? generalMobileScripts() : "";

			$body.hasClass("home") ? frontPageScripts() : "";
			$body.hasClass("tax-product_cat") ? archiveProduct() : "";
			$body.hasClass("single-product") ? initSingleProduct() : "";
			$body.hasClass("woocommerce-checkout") ? initCheckout() : "";
		});
	});
})(jQuery, this);
